import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Card, Col, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import Logs from '../school/Logs';
import dayjs from 'dayjs';
import OrphanTable from './OrphanTable';
import { getOrphanage, getContactByOrphanageId } from 'lib/supabaseQueries';

const OrphanageDetails = () => {
  const { id } = useParams();

  const { data: orphanageData } = useQuery({
    queryKey: ['orphanage', id],
    queryFn: () => getOrphanage(id),
    enabled: !!id
  });

  const { data: contactData } = useQuery({
    queryKey: ['contact', 'orphanage', id],
    queryFn: () => getContactByOrphanageId(id),
    enabled: !!id
  });

  const orphanage = orphanageData?.data;
  const contacts = contactData?.data || [];

  return (
    <Fragment>
      <Card className="mb-3">
        <FalconCardHeader
          title={<h4 className="fw-bold">Orphanage Details</h4>}
          light={false}
          titleTag="div"
          className="pb-1"
          menuClassName="align-items-start"
        />

        <Card.Body>
          <Row>
            <Col>
              <Flex>
                <div className="donor-info-title">
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Serial Number</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Address</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>City</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Country</p>
                </div>
                <div>
                  <p className="mb-2 text-primary" style={{ fontSize: '1rem' }}>
                    {orphanage?.serial_number}
                  </p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{orphanage?.address}</p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{orphanage?.city}</p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{orphanage?.country}</p>
                </div>
              </Flex>
            </Col>
            <Col>
              <Flex>
                <div className="donor-info-title">
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Orphanage Name</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Registered Date</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Email</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Documents</p>
                </div>
                <div>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{orphanage?.name}</p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>
                    {dayjs(orphanage?.created_at).format('MMM-DD-YYYY')}
                  </p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{orphanage?.email}</p>
                  {orphanage?.document ? (
                    <p className="mb-2" style={{ fontSize: '1rem' }}>
                      <a
                        href={orphanage?.document}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        File URL{' '}
                      </a>
                    </p>
                  ) : (
                    ''
                  )}
                </div>
              </Flex>
            </Col>
          </Row>
          <hr />

          <FalconCardHeader
            title={<h4 className="fw-bold">Person To Contact</h4>}
            light={false}
            titleTag="div"
            className="p-0 pb-3"
            menuClassName="align-items-start"
          />

          <Row>
            <Col>
              <Flex>
                <div className="donor-info-title">
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Title</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Name</p>
                </div>
                <div>
                  <p className="mb-2 text-primary" style={{ fontSize: '1rem' }}>{contacts[0]?.title}</p>
                  {contacts[0] && (
                    <p className="mb-2" style={{ fontSize: '1rem' }}>
                      {`${contacts[0].first_name} ${contacts[0].last_name}`}
                    </p>
                  )}
                </div>
              </Flex>
            </Col>
            <Col>
              <Flex>
                <div className="donor-info-title">
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Email</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Phone Number</p>
                </div>
                <div>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{contacts[0]?.email}</p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{contacts[0]?.phone}</p>
                </div>
              </Flex>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Row className="my-3">
        <Col md={12} xxl={12} className="h-md-100">
          <OrphanTable />
        </Col>
      </Row>

      <Logs moduleType="Orphanage" />
    </Fragment>
  );
};

export default OrphanageDetails;
